"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidExpression = isValidExpression;
const FormulaParser_1 = require("../parser/FormulaParser");
const FormulaTokenizer_1 = require("../tokenizer/FormulaTokenizer");
/**
 * Verify if the given expression is valid formula
 * @param expression expression to evaluate
 * @returns {boolean} true if the expression is valid
 */
function isValidExpression(expression) {
    try {
        const fTokenizer = new FormulaTokenizer_1.FormulaTokenizer();
        const fParser = new FormulaParser_1.FormulaParser();
        const tokens = fTokenizer.execute(expression);
        return fParser.isValidFormula(tokens);
    }
    catch (_a) {
        return false;
    }
}
